import { stringify } from "query-string";
import { Dict, PaginatedApiResponse } from "../..";
import { ApiResponse, ListSort } from "../models";
import { CreateShortlistDto, Project, Shortlist } from "../models/project";

import { LeadRequirement } from "../models/requirement";
import * as http from "./http";
import ApiService from "./service";

export class ShortlistService extends ApiService {
  async createShortList(data: CreateShortlistDto) {
    const url = `${this.apiDomain}/api/shortlist`;
    const response = await http.post<ApiResponse<any>>(url, data, this.store);
    return response.data;
  }

  async getShortList(requirementId: string) {
    const url = `${this.apiDomain}/api/shortlist?requirementId=${requirementId}`;
    const response = await http.get<ApiResponse<Shortlist>>(url, this.store);
    return response.data;
  }

  async deleteShortlistedProperties(shortlistIds: string[]) {
    const url = `${this.apiDomain}/api/shortlist/remove`;
    const response = await http.post<ApiResponse<any>>(
      url,
      { shortlistIds },
      this.store
    );
    return response.data;
  }

  public async mergePropeties(
    data: CreateShortlistDto
  ): Promise<any> {
    const url = `${this.apiDomain}/api/shortlist/merge-properties`;
    const response = await http.post<ApiResponse<any>>(
      url,
      data,
      this.store
    );
    return response?.data;
  }
}
